module.exports = __webpack_public_path__ + "assets/img/btn-back-f070bc3d.png";